<template>
  <v-container class="ticket">
    <div class="ticket-header">
      <p>Директору </p>
      <p>ООО &quot;Новая Энергетика&quot; </p>
      <p>Чуханову А.В</p>

      <p style="margin-bottom: 0;">От <v-text-field prepend-inner-icon="a" v-model="name" :placeholder="placeholders['name']" :readonly="isFinished" style="width: 300px;" class="ticket-text-input" :rules="[rules.required]"></v-text-field></p>

      <p style="margin-bottom: 0;" v-if="isIndividual">(Ф.И.О заявителя) </p>
      <p v-else style="margin-bottom: 0;">(наименование организации) </p>

      <p style="margin-bottom: 10px;"><v-textarea prepend-inner-icon="a" rows="1" auto-grow v-model="address" placeholder="Населенный пункт, ул. хххххх, д.хх, оф. хх" :readonly="isFinished" style="width: 300px;" class="ticket-text-input" :rules="[rules.required]"></v-textarea></p>
      <p style="margin-bottom: 0;">(адрес)</p>

      <p style="margin-bottom: 10px;"><v-text-field class="ticket-header-input" style="width: 186px" placeholder="+7 ххх ххх-хх-хх" v-model="phoneNumbers"></v-text-field> <v-text-field class="ticket-header-input" style="width: 186px" placeholder="xxx-xxxx" v-model="fax"></v-text-field></p>
      <p style="margin-bottom: 0;"><span style="margin-right: 161px">(телефон)</span><span>(факс)</span></p>

      <p style="margin-bottom: 10px;"><v-textarea prepend-inner-icon="a" rows="1" auto-grow v-model="email" placeholder="example@mail.com" :readonly="isFinished" style="width: 300px;" class="ticket-text-input" :rules="[rules.required, rules.email]"></v-textarea></p>
      <p style="margin-bottom: 0;">(адрес электронной почты)</p>

      <p style="margin-bottom: 0;"><v-text-field prepend-inner-icon="a" v-model="inn" placeholder="xxxxxxxxxx" :readonly="isFinished" style="width: 300px;" class="ticket-text-input" :rules="[rules.required, rules.inn]"></v-text-field></p>
      <p style="margin-bottom: 0;">(ИНН)</p>

      <div v-if="!isIndividual">
        <p style="margin-bottom: 0;"><v-text-field prepend-inner-icon="a" v-model="rs" placeholder="xxxxxxxxxxxxxxxxxxxx" :readonly="isFinished" style="width: 300px;" class="ticket-text-input" :rules="[rules.required, rules.rs]"></v-text-field></p>
        <p style="margin-bottom: 0;">(р/с)</p>
        <p style="margin-bottom: 0;"><v-text-field prepend-inner-icon="a" v-model="bik" placeholder="xxxxxxxxx" :readonly="isFinished" style="width: 300px;" class="ticket-text-input" :rules="[rules.required, rules.bik]"></v-text-field></p>
        <p style="margin-bottom: 0;">(БИК)</p>
        <p style="margin-bottom: 0;"><v-text-field prepend-inner-icon="a" placeholder="ПАО Сбербанк" v-model="bank" :readonly="isFinished" style="width: 300px;" class="ticket-text-input" :rules="[rules.required]"></v-text-field></p>
        <p>(Наименование Банка)</p>
      </div>

      <p> № <v-text-field prepend-inner-icon="a" style="min-width: 80px; width: 163px;" class="ticket-header-input" v-model="number" readonly></v-text-field> от <v-text-field style="width: 186px;" prepend-inner-icon="a" class="ticket-header-input" v-model="curDate" readonly></v-text-field></p>
    </div>
    <p class="ticket-title"><strong>ЗАЯВЛЕНИЕ</strong></p>
    <p class="ticket-title mt-1"><strong>о подключении (технологическом присоединении) (заключении договора о подключении (технологическом присоединении)) объекта капитального строительства к централизованным системам горячего водоснабжения</strong></p>

    <v-textarea auto-grow rows="1" class="pt-0 template-text" v-model="requisites" :rules="[rules.required]" :readonly="isFinished" row-height="20" :placeholder="placeholders['requisites']">
      ></v-textarea>
    <p class="ticket-field-caption"><span v-if="!isIndividual">(полное и сокращенное наименование)</span><span v-else>(Ф.И.О. заявителя)</span></p>

    <p style="margin-bottom: 0;">в соответствии с законом от 07.12.2011 №416-ФЗ «О водоснабжении и водоотведении» просит заключить договор о подключении (технологическом присоединении) объекта капитального строительства к централизованным системам горячего водоснабжения и подключить к централизованным системам горячего водоснабжения объект капитального строительства:</p>

    <v-textarea auto-grow rows="1" class="pt-0" :rules="[rules.required]" v-model="object" :placeholder="placeholders['object']" :readonly="isFinished"></v-textarea>
    <p class="ticket-field-caption"> (наименование подключаемого объекта) </p>

    <p style="margin-bottom: 0;">расположенный (располагаемый) на земельном участке:
      <v-textarea auto-grow rows="1" class="pt-0 mb-0 ticket-text-input" :rules="[rules.required]" v-model="objectAddress" :readonly="isFinished" placeholder="25:хх:хххххх:хххх"></v-textarea>
    </p>
    <p class="ticket-field-caption-right"> (кадастровый номер земельного участка) </p>

    <p>Данные об общей подключаемой нагрузке объекта капитального строительства (указывается согласно прилагаемого баланса водопотребления и водоотведения): </p>
    <p class="mt-3 mb-0 pb-0">по водоснабжению <v-text-field :readonly="isFinished" type="number" v-model="p1" class="text-number-input" min="0" :rules="[rules.numForm]"></v-text-field> м<sup>3</sup>/сут</p>

    <p style="margin-bottom: 0">Приложения: </p>

    <p style="margin-bottom: 0;">1) доверенность представителя от
      <v-menu transition="scale-transition" :close-on-content-click="false" offset-y v-model="isProxyOpened" max-width="300" style="display: inline-block;" :readonly="isFinished">
        <template v-slot:activator="{ on }">
          <v-text-field prepend-inner-icon="a" v-model="proxyDateFormatted" @blur="proxyDate = parseDate(proxyDateFormatted)" placeholder="Дата" color="secondary" readonly v-on="on" class="ticket-text-input-file"></v-text-field>
        </template>
        <v-date-picker v-model="proxyDate" color="secondary" locale="ru-ru" :max="today" @click:month="isProxyOpened = false"></v-date-picker>
      </v-menu>
      №
      <v-text-field placeholder="номер" prepend-inner-icon="a" :readonly="isFinished" v-model="proxyNum" style="width: 150px;" maxlength="15" class="ticket-text-input-file">
      </v-text-field>
      (если заявление подписывается представителем заявителя);
      <v-file-input v-if="isOperator" label="Вставить файл (макс. размер 10МБ)" append-icon="arrow_downward" @click:append="downloadFile('file_1')" class="file-input" :rules="[rules.requiredFiles, rules.filesSize]" v-model="file1" multiple>
      </v-file-input>
      <v-file-input label="Вставить файл (макс. размер 10МБ)" v-else :disabled="isFinished" class="file-input" :rules="[rules.requiredFiles, rules.filesSize]" v-model="file1" multiple>
      </v-file-input>
    </p>

    <p style="margin-bottom: 0;">2) копии учредительных документов, а также документы, подтверждающие полномочия лица, подписавшего заявление (для юридических лиц и индивидуальных предпринимателей), паспорта (для физических лиц);
      <v-file-input v-if="isOperator" append-icon="arrow_downward" @click:append="downloadFile('file_2')" label="Вставить файл (макс. размер 10МБ)" class="file-input" v-model="file2" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
      <v-file-input v-else :disabled="isFinished" label="Вставить файл (макс. размер 10МБ)" class="file-input" v-model="file2" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
    </p>
    <p style="margin-bottom: 0;">3) копии правоустанавливающих документов на земельный участок;
      <v-file-input v-if="isOperator" append-icon="arrow_downward" @click:append="downloadFile('file_3')" label="Вставить файл (макс. размер 10МБ)" v-model="file3" multiple class="file-input" :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
      <v-file-input :disabled="isFinished" v-else label="Вставить файл (макс. размер 10МБ)" v-model="file3" class="file-input" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
    </p>
    <p style="margin-bottom: 0;"> 4) ситуационный план расположения объекта с привязкой к территории населенного пункта;
      <v-file-input append-icon="arrow_downward" v-if="isOperator" @click:append="downloadFile('file_4')" label="Вставить файл (макс. размер 10МБ)" class="file-input" multiple v-model="file4" :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
      <v-file-input :disabled="isFinished" v-else label="Вставить файл  (макс. размер 10МБ)" class="file-input" v-model="file4" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
    </p>
    <p style="margin-bottom: 0;">5) топографическая карта участка в масштабе 1:500 (со всеми наземными и подземными коммуникациями и сооружениями), согласованная с эксплуатирующими организациями;
      <v-file-input append-icon="arrow_downward" v-if="isOperator" @click:append="downloadFile('file_5')" label="Вставить файл  (макс. размер 10МБ)" v-model="file5" class="file-input" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
      <v-file-input :disabled="isFinished" v-else label="Вставить файл (макс. размер 10МБ)" v-model="file5" class="file-input" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
    </p>
    <p style="margin-bottom: 0;">6) информация о сроках строительства (реконструкции) и ввода в эксплуатацию строящегося (реконструируемого) объекта;
      <v-file-input append-icon="arrow_downward" v-if="isOperator" @click:append="downloadFile('file_6')" label="Вставить файл (макс. размер 10МБ)" class="file-input" v-model="file6" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
      <v-file-input :disabled="isFinished" v-else label="Вставить файл  (макс. размер 10МБ)" class="file-input" v-model="file6" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
    </p>
    <p style="margin-bottom: 0;">7) баланс водопотребления и водоотведения подключаемого объекта в период использования максимальной величины мощности (нагрузки) с указанием целей использования холодной воды и распределением объемов подключаемой нагрузки по целям использования, в том числе на пожаротушение, периодические нужды, заполнение и опорожнение бассейнов, прием поверхностных сточных вод, а также с распределением общего объема сточных вод по канализационным выпускам (в процентах);
      <v-file-input append-icon="arrow_downward" v-if="isOperator" @click:append="downloadFile('file_7')" label="Вставить файл (макс. размер 10МБ)" class="file-input" v-model="file7" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
      <v-file-input v-else label="Вставить файл  (макс. размер 10МБ)" class="file-input" v-model="file7" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
    </p>
    <p style="margin-bottom: 0;">8) сведения о составе и свойствах сточных вод, намеченных к отведению в централизованную систему водоотведения;
      <v-file-input append-icon="arrow_downward" v-if="isOperator" @click:append="downloadFile('file_8')" label="Вставить файл (макс. размер 10МБ)" class="file-input" v-model="file8" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
      <v-file-input :disabled="isFinished" v-else label="Вставить файл  (макс. размер 10МБ)" class="file-input" v-model="file8" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
    </p>
    <p style="margin-bottom: 0;">9) сведения о назначении объекта, высоте и об этажности зданий, строений и сооружений.
      <v-file-input append-icon="arrow_downward" v-if="isOperator" @click:append="downloadFile('file_9')" label="Вставить файл (макс. размер 10МБ)" class="file-input" v-model="file9" multiple :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
      <v-file-input :disabled="isFinished" v-else multiple label="Вставить файл  (макс. размер 10МБ)" class="file-input" v-model="file9" :rules="[rules.requiredFiles, rules.filesSize]">
      </v-file-input>
    </p>
  </v-container>
</template>
<script>
import { convertDate, parseDate, validateInn, fileListToBase64, _base64ToArrayBuffer, downloadFile } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'TeploTemplate',

  props: {
    isIndividual: {
      default: undefined
    },
    ticketId: {
      default: null
    },
    ticketInfo: {
      default: null
    },
    isFinished: {
      default: false
    },
    isOperator: {
      default: false
    }
  },

  data: () => ({
    curDate: convertDate(new Date().toISOString().substr(0, 10)),
    file1: [],
    file2: [],
    file3: [],
    file4: [],
    file5: [],
    file6: [],
    file7: [],
    file8: [],
    file9: [],
    p1: 0,
    name: '',
    address: '',
    email: '',
    fax: '',
    phoneNumbers: '',
    inn: '',
    rs: '',
    bik: '',
    bank: '',
    requisites: '',
    object: '',
    objectAddress: '',
    proxyNum: '',
    number: '',
    isProxyOpened: false,
    proxyDate: null,
    proxyDateFormatted: null,
    rules: {
      required: value => !!value || 'Обязательное поле',
      requiredFiles: value => value.length > 0 || 'Обязательное поле',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Неверный формат e-mail'
      },
      notZero: value => value > 0 || 'Значение должно быть больше 0',
      numForm: v => /^\d{1,4}((\.|\,)(\d{1,4})){0,1}$/.test(v) || 'Не больше 4-х цифр до и после запятой',
      inn: v => validateInn(v),
      rs: v => !/[^0-9]/.test(v) && v.length == 20 || 'p/c должен состоять из 20-ти цифр',
      bik: v => !/[^0-9]/.test(v) && v.length == 9 || 'БИК должен состоять из 9-ти цифр',
      fileSize: v => v && v.size <= 10485760 || 'Размер файла превышает 10МБ',
      filesSize: v => v.every((elem) => elem && elem.size <= 10485760) || 'Размер файла превышает 10МБ'
    },
  }),

  computed: {
    today: () => { return new Date().toISOString().substr(0, 10) },
    computedProxyDateFormatted() {
      return convertDate(this.proxyDate)
    },
    placeholders: function() {
      if (this.isIndividual) {
        return {
          'name': 'Иванова Ивана Ивановича',
          'requisites': 'Иванов Иван Иванович',
          'object': 'Индивидуальный жилой дом',
          'FIO': 'Иванов Иван Иванович'
        }
      } else {
        return {
          'name': 'ООО «ВостПромСтрой – Холдинг»',
          'requisites': 'Общество с ограниченной ответственностью «ВостПромСтрой – Холдинг» в лице генерального директора Иванова Ивана Ивановича',
          'object': 'Административное здание',
          'FIO': 'Генеральный директор Иванов Иван Иванович'
        }
      }
    },
    formData: async function() {
      let proxyDate = ''
      if (this.proxyDateFormatted != null) {
        proxyDate = this.proxyDateFormatted
      }
      let filesArr1 = await fileListToBase64(this.file1)
      let filesArr2 = await fileListToBase64(this.file2)
      let filesArr3 = this.file3 == [] ? null : await fileListToBase64(this.file3)
      let filesArr4 = this.file4 == [] ? null : await fileListToBase64(this.file4)
      let filesArr5 = this.file5 == [] ? null : await fileListToBase64(this.file5)
      let filesArr6 = this.file6 == [] ? null : await fileListToBase64(this.file6)
      let filesArr7 = this.file7 == [] ? null : await fileListToBase64(this.file7)
      let filesArr8 = this.file8 == [] ? null : await fileListToBase64(this.file8)
      let filesArr9 = this.file9 == [] ? null : await fileListToBase64(this.file9)
      let fileArray = [filesArr1, filesArr2, filesArr3, filesArr4, filesArr5, filesArr6, filesArr7, filesArr8, filesArr9]
      const data = {
        '000100': this.name,
        '000200': this.address,
        '000600': this.inn,
        '001700': this.rs,
        '000800': this.bik,
        '000900': this.bank,
        //'00700': this.number,
        //'00800': this.curDate,
        '001000': this.requisites,
        '001100': this.object,
        '001200': this.objectAddress,
        '001300': this.p1,
        '001600': this.proxyNum,
        '001500': proxyDate,
        '004100': 'today_date',
        '000300': this.phoneNumbers,
        '000400': this.fax,
        '000500': this.email,
        'file_1': {
          names: this.file1.map(function(item) {
            return item.name
          }),
          files: fileArray[0]
        },
        'file_2': {
          names: this.file2.map(function(item) {
            return item.name
          }),
          files: fileArray[1]
        },
        'file_3': {
          names: this.file3.map(function(item) {
            return item.name
          }),
          files: fileArray[2]
        },
        'file_4': {
          names: this.file4.map(function(item) {
            return item.name
          }),
          files: fileArray[3]
        },
        'file_5': {
          names: this.file5.map(function(item) {
            return item.name
          }),
          files: fileArray[4]
        },
        'file_6': {
          names: this.file6.map(function(item) {
            return item.name
          }),
          files: fileArray[5]
        },
        'file_7': {
          names: this.file7.map(function(item) {
            return item.name
          }),
          files: fileArray[6]
        },
        'file_8': {
          names: this.file8.map(function(item) {
            return item.name
          }),
          files: fileArray[7]
        },
        'file_9': {
          names: this.file9.map(function(item) {
            return item.name
          }),
          files: fileArray[8]
        },
        'user': this.userLogin
      }
      return data
    },
    ...mapGetters({
      userLogin: 'user/userLogin'
    }),
  },

  watch: {
    proxyDate(val) {
      this.proxyDateFormatted = convertDate(this.proxyDate)
    }
  },

  methods: {
    parseDate: parseDate,
    getTicketInfo: async function() {
      this.searchDialog = true
      try {
        const resp = await this.$api.Account.getTicketInfo(this.ticketId)
        this.ticketInfo = resp.data
        console.log(resp.data)
        this.searchDialog = false
      } catch (e) {
        const err = e
        this.searchDialog = false
        let error = 'Не удалось получить информацию о заявке. Попробуйте повторить запрос позднее'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    downloadFile: function(file) {
      var mime = require('mime-types')
      for (let f in this.ticketInfo['fields'][file]) {
        let mimeType = mime.lookup(this.ticketInfo['fields'][file][f]['file_type'])
        downloadFile({ 'data': _base64ToArrayBuffer(this.ticketInfo['fields'][file][f]['file']) }, this.ticketInfo['fields'][file][f]['file_name'], mimeType)
      }
    },
    makeFileForIE: function(file) {
      let blob = new Blob([_base64ToArrayBuffer(file['file'])], { type: file['file_type'] })
      blob['lastModifiedDate'] = new Date()
      blob['name'] = file['file_name']
      return blob
    },
    parseFile: function(item) {
      return new File([_base64ToArrayBuffer(item['file'])], item['file_name'])
    },
    parseFileIE: function(item) {
      return this.makeFileForIE(item)
    }
  },

  created: async function() {
    //await this.getTicketInfo()
    if (this.ticketInfo) {
      this.name = this.ticketInfo['fields']['000100']
      this.address = this.ticketInfo['fields']['000200']
      this.inn = this.ticketInfo['fields']['000600']
      if (!this.isIndividual) {
        this.rs = this.ticketInfo['fields']['001700']
        this.bik = this.ticketInfo['fields']['000800']
        this.bank = this.ticketInfo['fields']['000900']
      }
      this.number = this.ticketInfo['code']
      this.curDate = this.ticketInfo['fields']['00800']
      this.requisites = this.ticketInfo['fields']['001000']
      this.object = this.ticketInfo['fields']['001100']
      this.objectAddress = this.ticketInfo['fields']['001200']
      this.p1 = this.ticketInfo['fields']['001300']
      this.fax = this.ticketInfo['fields']['000400']
      this.email = this.ticketInfo['fields']['000500']
      this.proxyNum = this.ticketInfo['fields']['001600']
      this.proxyDateFormatted = this.ticketInfo['fields']['001500']
      this.curDate = this.ticketInfo['fields']['004100']
      this.phoneNumbers = this.ticketInfo['fields']['000300']
      try {
        this.file1 = this.ticketInfo['fields']['file_1'].map(this.parseFile)
        this.file2 = this.ticketInfo['fields']['file_2'].map(this.parseFile)
        if ('file_3' in this.ticketInfo['fields']) this.file3 = this.ticketInfo['fields']['file_3'].map(this.parseFile)
        if ('file_4' in this.ticketInfo['fields']) this.file4 = this.ticketInfo['fields']['file_4'].map(this.parseFile)
        if ('file_5' in this.ticketInfo['fields']) this.file5 = this.ticketInfo['fields']['file_5'].map(this.parseFile)
        if ('file_6' in this.ticketInfo['fields']) this.file6 = this.ticketInfo['fields']['file_6'].map(this.parseFile)
        if ('file_7' in this.ticketInfo['fields']) this.file7 = this.ticketInfo['fields']['file_7'].map(this.parseFile)
        if ('file_8' in this.ticketInfo['fields']) this.file8 = this.ticketInfo['fields']['file_8'].map(this.parseFile)
        if ('file_9' in this.ticketInfo['fields']) this.file9 = this.ticketInfo['fields']['file_9'].map(this.parseFile)
      } catch (err) {
        this.file1 = this.ticketInfo['fields']['file_1'].map(this.parseFileIE)
        this.file2 = this.ticketInfo['fields']['file_2'].map(this.parseFileIE)
        if ('file_3' in this.ticketInfo['fields']) this.file3 = this.ticketInfo['fields']['file_3'].map(this.parseFileIE)
        if ('file_4' in this.ticketInfo['fields']) this.file4 = this.ticketInfo['fields']['file_4'].map(this.parseFileIE)
        if ('file_5' in this.ticketInfo['fields']) this.file5 = this.ticketInfo['fields']['file_5'].map(this.parseFileIE)
        if ('file_6' in this.ticketInfo['fields']) this.file6 = this.ticketInfo['fields']['file_6'].map(this.parseFileIE)
        if ('file_7' in this.ticketInfo['fields']) this.file7 = this.ticketInfo['fields']['file_7'].map(this.parseFileIE)
        if ('file_8' in this.ticketInfo['fields']) this.file8 = this.ticketInfo['fields']['file_8'].map(this.parseFileIE)
        if ('file_9' in this.ticketInfo['fields']) this.file9 = this.ticketInfo['fields']['file_9'].map(this.parseFileIE)
      }
    }
    //console.log(this.isIndividual)
  },

}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ticket {
  font-family: 'Times New Roman';
}

.ticket-header {
  text-align: right;
}

.ticket-field-caption {
  text-align: center;
  margin-top: -15px !important;
}

.ticket-field-caption-right {
  text-align: right;
  margin-top: 5px !important;
  margin-right: 60px;
}

.ticket-header p {
  margin-bottom: 5px;
}

.ticket-title {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}

.ticket table {
  border: 1px solid grey;
  border-collapse: collapse;
}

.ticket th {
  text-align: center;
  vertical-align: middle;
  font-weight: normal !important;
}

.ticket th,
td {
  padding: 5px;
  border: 1px solid grey;
}

.ticket-text-input {
  display: inline-block;
  margin-left: 10px;
  margin-bottom: 0;
  padding: 0;
  height: 40px;
  min-width: 380px;
}

.ticket-header-input {
  display: inline-block;
  margin-left: 10px;
  margin-bottom: 0;
  padding: 0;
  height: 40px;
  min-width: 170px;
}

.ticket-text-input-file {
  display: inline-block;
  margin-left: 10px;
  margin-bottom: 0;
  padding: 0;
  height: 40px;
  min-width: 90px;
}

.number-input {
  width: 110px;
  padding: 10px;
  display: inline-block;
}

.text-number-input {
  width: 200px;
  padding: 0;
  padding-left: 10px;
  display: inline-block;
}

.select-input {
  display: inline-block;
  width: 270px;
  margin-left: 15px;
  margin-bottom: 0;
}

.file-input {
  width: 350px;
  margin-bottom: 0;
  padding-top: 7px;
}

.download-file {
  font-size: 10pt;
  color: #005caf;
  text-decoration: underline;
  cursor: pointer;
}

.template-text textarea {
  line-height: 20px !important;
}
</style>